export const HOME = {
  emergentLink: "emergent-link",
};

export const SIDEBAR = {
  nav: "sidebar-nav",
  overview: "sidebar-overview",
  shipments: "sidebar-shipments",
  fleet: "sidebar-fleet",
  analytics: "sidebar-analytics",
  routes: "sidebar-routes",
  collapse: "sidebar-collapse-btn",
};

export const HEADER = {
  root: "header-root",
  search: "header-search-input",
  newShipment: "header-new-shipment-btn",
  notifications: "header-notifications-btn",
};

export const OVERVIEW = {
  root: "overview-page",
  kpiTotalShipments: "kpi-total-shipments",
  kpiInTransit: "kpi-in-transit",
  kpiOnTimeRate: "kpi-on-time-rate",
  kpiRevenue: "kpi-revenue",
  recentShipments: "recent-shipments-table",
};

export const SHIPMENTS = {
  root: "shipments-page",
  searchInput: "shipment-search-input",
  statusFilter: "shipment-status-filter",
  createBtn: "create-shipment-btn",
  table: "shipments-table",
  createDialog: "create-shipment-dialog",
  submitBtn: "create-shipment-submit-btn",
  editBtn: "edit-shipment-btn",
  deleteBtn: "delete-shipment-btn",
};

export const FLEET = {
  root: "fleet-page",
  vehicleCard: "vehicle-card",
  addBtn: "add-vehicle-btn",
  statusFilter: "fleet-status-filter",
};

export const ANALYTICS = {
  root: "analytics-page",
  volumeChart: "shipment-volume-chart",
  performanceChart: "delivery-performance-chart",
  costChart: "cost-breakdown-chart",
  utilizationChart: "fleet-utilization-chart",
};

export const ROUTES = {
  root: "routes-page",
  table: "routes-table",
  createBtn: "create-route-btn",
  createDialog: "create-route-dialog",
  submitBtn: "create-route-submit-btn",
};
